var _rect, _path, _path2, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.774 432L237.982 408.409C206.878 380.886 181.164 357.143 160.839 337.181C140.514 317.219 124.346 299.299 112.336 283.42C100.325 267.542 91.9333 252.948 87.16 239.64C82.3867 226.332 80 212.722 80 198.809C80 170.379 89.7007 146.636 109.102 127.582C128.503 108.527 152.678 99 181.626 99C197.64 99 212.884 102.327 227.358 108.981C241.832 115.635 254.304 125.011 264.774 137.109C275.245 125.011 287.717 115.635 302.191 108.981C316.665 102.327 331.909 99 347.923 99C376.871 99 401.046 108.527 420.447 127.582C439.848 146.636 449.549 170.379 449.549 198.809C449.549 212.722 447.162 226.332 442.389 239.64C437.615 252.948 429.224 267.542 417.213 283.42C405.203 299.299 389.035 317.219 368.71 337.181C348.385 357.143 322.67 380.886 291.567 408.409L264.774 432Z",
    fill: "#666666",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.625 256.802C205.004 203.392 243.823 161.716 262.061 147.554C321.462 166.976 335.444 228.478 335.01 256.802C340.22 338.131 285.943 349.359 258.153 344.807C197.709 336.31 191.283 282.596 195.625 256.802Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_226_10233",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 99,
    width: 244,
    height: 283
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 143.767,
    y: 99,
    width: 242.295,
    height: 282.223,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_226_10233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.914 357.704C241.863 357.704 222.639 348.492 207.243 330.069C191.847 311.646 184.149 288.716 184.149 261.277C184.149 249.126 186.505 236.975 191.216 224.824C195.928 212.672 201.817 201.011 208.884 189.84C215.951 178.668 223.606 168.183 231.851 158.383C240.096 148.584 247.752 140.059 254.819 132.807C256.165 131.239 257.721 130.112 259.488 129.426C261.255 128.74 263.063 128.397 264.914 128.397C266.765 128.397 268.574 128.74 270.341 129.426C272.107 130.112 273.664 131.239 275.01 132.807C282.077 140.059 289.733 148.584 297.977 158.383C306.222 168.183 313.878 178.668 320.945 189.84C328.012 201.011 333.901 212.672 338.612 224.824C343.324 236.975 345.679 249.126 345.679 261.277C345.679 288.716 337.981 311.646 322.586 330.069C307.19 348.492 287.966 357.704 264.914 357.704ZM264.914 334.185C282.413 334.185 296.884 327.277 308.325 313.459C319.767 299.642 325.488 282.248 325.488 261.277C325.488 246.97 320.398 230.801 310.218 212.77C300.039 194.739 284.937 175.042 264.914 153.68C244.891 175.042 229.79 194.739 219.61 212.77C209.431 230.801 204.341 246.97 204.341 261.277C204.341 282.248 210.061 299.642 221.503 313.459C232.945 327.277 247.415 334.185 264.914 334.185ZM267.691 322.426C269.71 322.23 271.434 321.299 272.865 319.633C274.295 317.967 275.01 315.958 275.01 313.606C275.01 310.862 274.253 308.658 272.738 306.992C271.224 305.326 269.289 304.591 266.933 304.787C260.035 305.375 252.715 303.17 244.975 298.172C237.236 293.175 232.356 284.11 230.337 270.979C230 268.823 229.117 267.059 227.687 265.687C226.257 264.315 224.616 263.629 222.765 263.629C220.409 263.629 218.475 264.658 216.96 266.716C215.446 268.774 214.941 271.175 215.446 273.919C218.306 291.754 225.037 304.493 235.637 312.136C246.237 319.78 256.922 323.21 267.691 322.426Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/내과_당뇨병.e930e6ee813109474a8ffc55c70473b8.svg";
export { ForwardRef as ReactComponent };